import React, { useCallback, useContext, useEffect, useState } from "react";
import LeftNav from "@/layout/LeftNav";
import RightContent from "@/layout/RightContent";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { Loading } from "@jd/focus-desktop-comps";
import { useLocation } from "react-router-dom";
import classnames from "classnames";
import "./index.less";
import config, { ConfigEnum } from "@/config/config";
import { FocusSDK, isFocusEnv } from "@/utils";
import { UserState } from "@/models/user";
import { connect } from "dvajs";

import ChatState from "@/types/chat/State";
import { usePrevious } from "@/utils/chat/index";
import { Employee } from "@/types/chat";
import bus from "@/utils/bus";
import { getRealConfig, isMebjJZB } from "@/utils/tools";
import NavSetting from "./NavSetting/NavSetting";
import MessageMerge from "./MessageMerge";

function GlobalLayout({ children }: { children: any }) {
  const location = useLocation();
  const { authInfo, appRuntimeEnv, notifyDis, notifyStatus } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  // if (location.pathname === "/login") {
  //   return null;
  // }
  // if (!authInfo) {
  //   return (
  //     <div className="flex1 flex-center">
  //       <Loading />
  //     </div>
  //   );
  // }
  // 是否隐藏了左侧边栏
  console.log("notifyStatus`121`", notifyStatus);
  const leftSiderEnable = config[ConfigEnum.LEFT_SIDER_ENABLE];
  return (
    <div
      className={classnames(
        "appLayout",
        ...(appRuntimeEnv.envConfig.layoutClassNames || []),
        { "has-notify": !isFocusEnv() && notifyStatus !== "granted" },
        { "is-close-notify": !notifyDis },
        leftSiderEnable ? "" : "hide-left-sider",
        !isMebjJZB() ? "xtbg" : ""
      )}
      style={{
        minWidth: isFocusEnv() ? "750px" : "960px"
      }}
    >
      {leftSiderEnable && <LeftNav />}
      <NavSetting />
      <RightContent>{children}</RightContent>
      <MessageMerge />
    </div>
  );
}

function mapStateToProps({ user }: { user: UserState }) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLayout);
